import React from "react";
import UniformServiceCardSection4 from "./UniformServiceCardSection4";
import uni1 from "../../../images/serviceimage/uni1.jpeg";
import uni2 from "../../../images/serviceimage/uni2.jpeg";
import uni3 from "../../../images/serviceimage/uni3.jpeg";
const UniformServiceSection4 = () => {
  return (
    <div id="pros ">
      <div class="bg-slate-100 lg:pb-52  ">
        <div class="fifth-content mt-44 text-center pt-32 ">
          <h1 class=" font-serif text-5xl text-blue-700">
            {" "}
            <a class="underline decoration-orange-700 "> Uniform</a>
          </h1>
          {/* <p class=" text-lg font-semibold leading-8 mt-10 mx-2 lg:px-80 ">
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Omnis sed
            et necessitatibus ipsam sunt temporibus aspernatur voluptatem ad,
          </p> */}
        </div>
        <div class=" lg:flex items-center w-full justify-evenly  ">
          <UniformServiceCardSection4
            title="Girls ( Class VI-VIII )"
            image={uni1}
            para="  Kurta - Salwar (Almond Brown )"
            para1="   Kothi (Specific Check Brown) "
            para2="Shocks - (White)"
            para3="Shoes - (Black)"
          />
          <UniformServiceCardSection4
            title="Girls ( Class P.G.-V )"
            image={uni2}
            para=" Shirt (Almond Brown , Green) and V-shaped Tunic Skirt (Gray Blackish , White)"
            para1="Tie(I-V) and   Belt "
            para2="Shocks - (Gray Blackish with Almond Brown lining  and White)"
            para3="Shoes - (Black & White)"
            // para4="Tie  & Belt "
          />
          {/* <UniformServiceCardSection4
            title="Girls ( Class P.G.-V )"
            image={uni3}
            para=" Shirt (Almond Brown) and V-shaped Tunic Skirt (Gray Blackish)"
            para1="   Kothi , Tie  & Belt "
            para2="Shocks - (Gray Blackish with Almond Brown lining)"
            para3="Shoes - (Black)"
            
          /> */}
        </div>
        <div class=" lg:flex items-center w-full justify-evenly  ">
          <UniformServiceCardSection4
            title="Boys ( Class P.G.-VIII)"
            image={uni3}
            para=" Shirt (Almond Brown and Green) and Pant/Shorts (Gray Blackish and White)"
            para1="   Tie(I-VIII) and Belt"
            para2="Shocks - (Gray Blackish with Almond Brown lining and White)"
            para3="Shoes - (Black and White)"
          />
        </div>
      </div>
    </div>
  );
};

export default UniformServiceSection4;
